"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SportsEnum;
(function (SportsEnum) {
    SportsEnum["football"] = "football";
    SportsEnum["rugbyUnion"] = "rugbyUnion";
    SportsEnum["rugbyLeague"] = "rugbyLeague";
    // basketball = 'basketball'
})(SportsEnum = exports.SportsEnum || (exports.SportsEnum = {}));
var SportsWithSpaceEnum;
(function (SportsWithSpaceEnum) {
    SportsWithSpaceEnum["football"] = "football";
    SportsWithSpaceEnum["rugby union"] = "rugby union";
    SportsWithSpaceEnum["rugby league"] = "rugby league";
})(SportsWithSpaceEnum = exports.SportsWithSpaceEnum || (exports.SportsWithSpaceEnum = {}));
//# sourceMappingURL=sportsEnum.js.map